import { z } from '@lucidlink/dto/z';
import { CreateGuestLinkCodec, GuestDetailsCodec, ManageGuestLinksCodec, } from './codecs';
export const DrawerConfigSchema = z.union([
    ManageGuestLinksCodec,
    CreateGuestLinkCodec,
    GuestDetailsCodec,
]);
